import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, Loader2, Mic, Send, Square, X } from 'lucide-react';
import { useVoce } from './useVoce';
import { fotoCompressa } from './fotoCompressa';

const TONDO = 'h-11 w-11 shrink-0 rounded-full flex items-center justify-center transition-colors disabled:opacity-50';

export const BarraDomanda = ({ occupato, onInvia, onAscolto }) => {
  const [testo, setTesto] = useState('');
  const [foto, setFoto] = useState(null);
  const file = useRef(null);
  const manda = (t) => {
    const domanda = (t ?? testo).trim() || (foto ? 'Cosa vedi in questa foto? Va bene secondo l\'HACCP?' : '');
    if (domanda.length < 2 || occupato) return;
    onInvia(domanda, foto);
    setTesto(''); setFoto(null);
  };
  const voce = useVoce((t) => manda(t));
  useEffect(() => { onAscolto(voce.stato !== 'fermo'); }, [voce.stato, onAscolto]);
  const scegli = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (f) fotoCompressa(f).then(setFoto).catch(() => toast.error('Foto non leggibile: riprova'));
  };
  const ascolto = voce.stato === 'ascolto';
  return (
    <div className="space-y-2">
      {foto && (
        <div className="relative inline-block" data-testid="assistente-foto-anteprima">
          <img src={foto} alt="Foto da inviare" className="h-20 rounded-lg border border-gray-200 object-cover" />
          <button onClick={() => setFoto(null)} className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-gray-900 text-white flex items-center justify-center" data-testid="assistente-foto-togli"><X className="h-3.5 w-3.5" /></button>
        </div>
      )}
      <div className="flex items-end gap-2">
        <input ref={file} type="file" accept="image/*" capture="environment" className="hidden" onChange={scegli} data-testid="assistente-foto-input" />
        <button onClick={() => file.current?.click()} disabled={occupato} className={`${TONDO} bg-gray-100 text-gray-700 hover:bg-gray-200`} aria-label="Fai una foto" data-testid="assistente-foto-btn"><Camera className="h-5 w-5" /></button>
        <textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={1} maxLength={1500} placeholder={ascolto ? 'Ti ascolto...' : 'Scrivi la domanda'}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); manda(); } }}
          className="flex-1 min-h-11 max-h-32 px-3.5 py-2.5 rounded-2xl border border-gray-300 text-sm text-gray-900 resize-none" style={{ background: '#fff' }} data-testid="assistente-input" />
        {voce.supportato && !testo.trim() && !foto ? (
          <button onClick={ascolto ? voce.ferma : voce.avvia} disabled={occupato || voce.stato === 'trascrivo'} aria-label={ascolto ? 'Ferma e invia' : 'Parla'}
            className={`${TONDO} ${ascolto ? 'bg-red-600 text-white animate-pulse' : 'bg-emerald-600 text-white hover:bg-emerald-700'}`} data-testid="assistente-voce-btn">
            {voce.stato === 'trascrivo' ? <Loader2 className="h-5 w-5 animate-spin" /> : ascolto ? <Square className="h-4 w-4" /> : <Mic className="h-5 w-5" />}
          </button>
        ) : (
          <button onClick={() => manda()} disabled={occupato} aria-label="Invia" className={`${TONDO} bg-gray-900 text-white hover:bg-black`} data-testid="assistente-invia-btn">
            {occupato ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-4 w-4" />}
          </button>
        )}
      </div>
      {ascolto && <p className="text-xs text-red-700" data-testid="assistente-voce-stato">Sto ascoltando: tocca il quadrato quando hai finito.</p>}
    </div>
  );
};
